var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("svg", { staticClass: "loader-payment-wrapper" }, [
    _c("circle", {
      staticClass: "path",
      attrs: { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }